import { AuditoriaBeanM } from './auditoria_bean';
import { ServiceCredencialesM } from './service-credenciales-bean';


export class DetParticipanteE {
  c_participante:Number;
  c_constancia:String;
  c_tipo:String;
  c_userid:String;
  x_nombres:String;
  x_correo:String;
  x_nota:String;
  x_nro_constancia:String;
  c_estado:Number;
  x_estado:String;
  x_uid_doc:String;
  x_uid_pdf:String;
  l_envio_correo:String;
  auditoriaBeanM:AuditoriaBeanM;
  serviceCredencialesM:ServiceCredencialesM;
}

export class DetParticipanteM {
  c_participante:Number;
  c_constancia:Number;
  c_tipo:String;
  c_userid:String;
  x_nombres:String;
  x_correo:String;
  x_nota:String;
  x_nro_constancia:String;
  c_estado:String;
  x_estado:String;
  x_uid_doc:String;
  x_uid_pdf:String;
  l_envio_correo:String;
}
export class MovFirmaParticipanteM{
  c_firma:Number;
  c_constancia:Number;
  c_estado:String;
  x_estado:String;
  x_uid:String;
  c_participante:Number;
  x_nombres:String;
  x_correo:String;
  x_ruta:String;
  x_actualizado:String;
}
export class DetParticipanteCsv{
  nombre: String;
  correo: String;
  nota: String;
  codigo:String;

  constructor(nombre: String, correo: String, nota: String, codigo :String){
    this.nombre = nombre;
    this.correo = correo;
    this.nota = nota;
    this.codigo = codigo;
  }
}
